module.exports = __webpack_public_path__ + "static/media/Methodology_right.2f24560f.jpg";